import { clsx } from "@cgc/ui/utils/clsx";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React, { PropsWithChildren } from "react";

type SectionProps = {
  props: any;
  className?: string;
};

type Props = PropsWithChildren<{
  root?: SectionProps;
  form?: SectionProps;
  input?: SectionProps;
  label?: SectionProps;
  showIcon?: boolean;
  onFocus?: () => void;
}>;

const FormComponent: React.FC<Props> = React.forwardRef(function FormComponent(
  { root, form, input, label, showIcon = true, onFocus, children },
  ref,
) {
  return (
    <div
      className={clsx(
        "border-cgc-green h-[40px] max-w-[630px] rounded-full border",
        root?.className,
      )}
      {...root?.props}
    >
      <form
        className={clsx(
          "flex h-full flex-row items-center px-2 pl-7",
          form?.className,
        )}
        {...form?.props}
      >
        <div className="grow">
          <input
            className={clsx(
              "focus:ring-none ring-none h-full w-full border-0 border-none p-0 outline-none outline-0 ring-0 focus:outline-none focus:outline-0 focus:ring-0",
              input?.className,
            )}
            ref={ref}
            onFocus={onFocus}
            placeholder="Search..."
            {...input?.props}
          />
        </div>
        {showIcon && (
          <label className="ml-auto" {...label?.props}>
            <MagnifyingGlassIcon className="h-6 w-6" />
          </label>
        )}
      </form>
      {children}
    </div>
  );
});

export default FormComponent;
